var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{attrs:{"type":"area","height":160,"options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }